'use client';

export { createFooterKYC } from './define';
export { FooterKYC } from './FooterKYC';
